import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { ProcessEntity } from '../../../../../../common/enums/processEntity';
import { ServiceType } from '../../../../../../common/enums/serviceType';
import { SomnologyOrganizationType } from '../../../../../../common/enums/somnologyOrganizationType';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { DiagnosticReportReadButtons } from '../../../../elements/carePathButtons/DiagnosticReportReadButtons';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { OsasAddendumAdd } from '../../utils/v1/addendum/OsasAddendumAdd';
import { OsasAddendumRead } from '../../utils/v1/addendum/OsasAddendumRead';
import { Osasc2V2DiagnosticReportNsiSummary } from './Osasc2V2DiagnosticReportNsiSummary';
import { Osasc2V2DiagnosticReportReadKsyosMedicalCenter } from './Osasc2V2DiagnosticReportReadKsyosMedicalCenter';
import { Osasc2V2DiagnosticReportReadNsi } from './Osasc2V2DiagnosticReportReadNsi';

export function Osasc2V2DiagnosticReportRead(props: ICustomControlDiagnosticReportReadProps) {
    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.diagnosticReport && props.diagnosticReport.dateSent}
                isFirstItem
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.diagnosticReport.performerOrganization?.name}
                practitionerName={
                    props.diagnosticReport.performerPractitioner
                        ? getDisplayName(props.diagnosticReport.performerPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={ServiceType.consultation}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />
            {props.diagnosticReport.customControlData?.somnologyOrganizationType === SomnologyOrganizationType.nsi && (
                <>
                    <Osasc2V2DiagnosticReportNsiSummary {...props} />
                    <Osasc2V2DiagnosticReportReadNsi {...props} />
                </>
            )}
            {props.diagnosticReport.customControlData?.somnologyOrganizationType ===
                SomnologyOrganizationType.ksyosMedicalCenter && (
                <>
                    <Osasc2V2DiagnosticReportReadKsyosMedicalCenter {...props} />

                    <OsasAddendumRead addendum={props.diagnosticReport.customControlData?.addendum} />

                    <OsasAddendumAdd
                        diagnosticReport={props.diagnosticReport}
                        processEntity={ProcessEntity.diagnosticReport}
                        reloadProcess={props.reloadProcess}
                        request={props.request}
                    />
                </>
            )}

            <DiagnosticReportReadButtons {...props} />
        </ProcessContainer>
    );
}
